import api from "@/api/api-config";

export async function getCollection() {
  return await api.get(`driver-invoice`);
}

export async function getByDriver(id) {
  return await api.get(`driver-invoice/${id}`);
}

export async function bulkUpload(file) {
  let formData = new FormData();
  formData.append("uploadedFile", file);
  return await api.post(`driver-invoice/bulk-upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export async function setPaid(userId, invoiceId) {
  return await api.post(`driver-invoice/${userId}/${invoiceId}`);
}

export async function getShowInvoices(userId) {
  return await api.get(`driver-invoice/show/${userId}`);
}
